import Route from '@ember/routing/route';

import { set } from '@ember/object';

export default class DetailRoute extends Route {
  model(params) {
    return params;
  }

  setupController(controller, model) {
    super.setupController(controller, model);
    var application = this.controllerFor('application');
    set(application, 'showCart', null);
    set(application, 'showMenu', null);
    set(controller, 'buyGroups', null);
    set(controller, 'buyMaestro', null);
    set(controller, 'privateData', null);
    set(controller, 'searchBy', null);
    set(controller, 'oreSelected', []);
    set(controller, 'oreSelectedDate', []);
    set(controller, 'language', null);
    set(controller, 'gender', null);
    set(controller, 'byGroupComp', null);

    controller.setProperties({
      id: model.id,
    });
    controller.loadPrivateTask.perform();
    controller.checkAvailabilityTask.perform();
  }

  resetController(controller) {
    controller.loadPrivateTask.cancelAll();
    controller.checkAvailabilityTask.cancelAll();
  }
}
